/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const VALID_CHARS_REGEX = /^[0-9a-zA-Z_-]+$/;
const PASSWORD_MESSAGE = 'A Senha deve ser preenchida com no mínimo 5 caracteres e ser igual a Confirmação de Senha';

export const uploadValidations = {
  owner: (form) => !!(form && form.ownerId),
  files: (form) => !!(form && form.files) && form.files.length > 0
};

export const uploadValidationMessages = {
  ownerId: 'É necessário selecionar um Usuário Destino',
  files: 'Ao menos 1 arquivo deve ser selecionado'
};

export const userValidations = {
  email: (form) => !form?.email ? true : EMAIL_REGEX.test(form?.email),
  accessId: (form) => !!(form && form.accessId) && VALID_CHARS_REGEX.test(form.accessId),
  password: (form) => 
    !!(form && form.password) && form.password === form.passwordConfirmation && form.password.length >= 5,
  role: (form) => !!(form && form.role) && form.role != -1,
  name: (form) => !!(form && form.name),
};

export const userValidationMessages = {
  email: 'Informe um e-mail válido',
  accessId: 'O Login ID deve ser preenchido e não pode possuir espaços',
  role: 'Uma Função deve ser selecionada',
  name: 'O Nome deve ser preenchido',
  password: PASSWORD_MESSAGE
};

export const resourceValidations = {
  path: (form) => !!(form && form.path),
  category: (form) => !!(form && form.category),
  name: (form) => !!(form && form.name)
};

export const resourceValidationMessages = {
  name: 'O Nome do recurso deve ser preenchido',
  path: 'O Caminho no Servidor do recurso deve ser preenchido',
  category: 'O Tipo do recurso deve ser preenchido'
};

export const signinValidations = {
  accessId: (form) => !!(form && form.accessId),
  password: (form) => !!(form && form.password)
};

export const signinValidationMessages = {
  accessId: 'O Login ID é obrigatório',
  password: 'A Senha é obrigatória'
};

export const alterPasswordValidations = {
  password: (form) => 
    !!(form && form.password) && form.password === form.passwordConfirmation && form.password.length >= 5
};

export const alterPasswordValidationMessages = {
  password: PASSWORD_MESSAGE
};
